import styled from 'styled-components';

export const Item = styled.li`
  list-style: none;
  list-style-position: inside;
  border-radius: 4px;

  display: flex;
  justify-content: space-between;

  line-height: 1.3em;
  padding: 0.5em 0.75em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0;
  font-size: 14px;

  &:hover {
    background: rgba(0,0,0,0.08);
  }

  & span:first-child {
    flex: 1;
    padding: 0 1em 0 0;
  }
  
  &:last-child {
    border-bottom: 0;
  }

  & span:last-child {
    min-width: 2.5em; 
    text-align: right;
    display: flex;
    align-items: center;
    padding: 0;
  } 
`;

export const Menu = styled.ul`
  padding: 1em;
  margin: 0;
  max-height: 400px;
  overflow: auto;
`;

export const A = styled.a`
`;
